
import {defineComponent} from "vue";
import OptionEditoPopin from "../../../../../common/components/vue/OptionEditoPopin.vue";
import ThreeColumnsEditoPopin from "../../../../../common/components/vue/ThreeColumnsEditoPopin.vue";
import EditoPopin from "../../../../../common/components/vue/EditoPopin.vue";
import {
    OfferDetail,
    OfferEditoPopin,
    OfferOptionEditoPopin,
    OfferThreeColumnsEditoPopin,
    TvDetails
} from "./models/SingleOfferDetail";
import InternetTvDetails from "./InternetTvDetails.vue";

export default defineComponent( {
    name: "InternetOfferDetails",
    components: {
        InternetTvDetails,
        ThreeColumnsEditoPopin,
        OptionEditoPopin,
        EditoPopin
    },
    props: {
        title: {
            type: String,
            required: true
        },
        details: {
            type: Array as () => Array<OfferDetail>,
            required: true
        },
        tvDetails: {
            type: Object as () => TvDetails | null,
            required: false,
            default: null
        },
        editoPopins: {
            type: Array as () => Array<OfferEditoPopin>,
            required: true
        },
        destinationPopin: {
            type: Object as () => OfferThreeColumnsEditoPopin | null,
            required: false,
            default: null
        },
        mobileOptionPopin: {
            type: Object as () => OfferOptionEditoPopin | null,
            required: false,
            default: null
        },
    },
    computed: {
        leftDetails(): Array<any> {
            return this.details.length > 3 ? this.details.slice(0, 3) : this.details;
        },
        rightDetails(): Array<any> {
            return this.details.length > 3 ? this.details.slice(3) : [];
        }
    },
    mounted() {
        this.addElementsForModalToggle();
    },
    updated() {
        this.addElementsForModalToggle();
    },
    methods: {
        addElementsForModalToggle() {
            document.querySelectorAll(".offer-attributes").forEach(
                function (edito: HTMLElement) {
                    const {oeventCategory, oeventLabel} = edito.dataset;

                    edito.querySelectorAll("a").forEach(
                        function (link) {
                            const hrefAttr = link.getAttribute("href");
                            if (hrefAttr.startsWith("#")) {
                                link.target = "_self";
                                link.dataset.bsToggle = "modal";
                                link.dataset.oeventCategory = oeventCategory;
                                link.dataset.oeventLabel = oeventLabel;
                                link.dataset.oeventAction = hrefAttr.substr(1);
                                link.className = "ob1-link-arrow ob1-link-small ob1-link-large";
                            } else {
                                link.target = "_blank";
                                link.dataset.oeventCategory = oeventCategory;
                                link.dataset.oeventLabel = "ouverture_nouvelle_fenetre";
                                link.dataset.oeventAction = hrefAttr.substr(1);
                            }
                        }
                    );

                    // Masquer les boutons avec data-bs-target
                    edito.querySelectorAll("[data-bs-target]").forEach(
                        function (element) {
                            element.classList.add("d-none");
                        }
                    );
                }
            );
        },
    }
});
